<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized-2">
<div class="heading heading-with-title heading-with-image" id="uncategorized-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Characters &amp; Places</h1>
</div>
</div>
<div class="heading-image-block heading-image-aspect-square heading-image-block-after-title-and-subtitle">
<div class="heading-image-size-container heading-image-width-250">
<img alt="" class="heading-image-image" src="images/blue-watercolor-flower.jpg"/>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-2-text">
<ul>
<li><b>Asgard</b>: One of the nine realms in Norse mythology; the location where the Aesir (the gods) live.</li>
<li><b>Baldr</b>: The god of light, previously killed by a mistletoe arrow. He now resides in Helheim with his wife, Nanna.</li>
<li><b>Dark Elve</b>s: Reside in the realm of Svartalfheim; invaders of Earth.</li>
<li><b>Dis (plural disir)</b>: An ancestral spirit.</li>
<li><b>Fenrir</b>: Known as the “great” wolf, is the son of Loki, and the brother of Lady Hel.</li>
<li><b>Freyja</b>: Norse goddess, married to Odin, stepmother to Thor. She lives in Asgard.</li>
<li><b>Garmr</b>: Lady Hel’s faithful dog.</li>
<li><b>Harley</b>: The reincarnated Erlking or Alder King, and Lady Hel’s mate.</li>
<li><b>Helheim</b>: Also called Hel, is one of the places the dead are received. It is ruled by Lady Hel. Helheim means <i>covered</i>, and cannot be compared with the Christian Hell of torture, fire or brimstone. Instead, some sources reference Helheim as a cold place, but still where feasts are held (such as is the case for the god Baldr, who is now there).</li>
<li><b>Heimdall</b>: He is a Norse god, who is considered the gods’ watchman. He resides at the entry to Asgard.</li>
<li><b>Jörmungandr</b>: Also called the Midgard Serpent, he is the son of Loki. It is prophesied that at Ragnarok, he will kill Thor.</li>
<li><b>Lady Hel</b>: The ruler of Helheim, a final resting place for the sick, elderly, and those who have not died with honor, and Loki’s daughter.</li>
<li><b>Loki</b>: Loki is the god of mischief, the mother of Sleipnir, and the father of Lady Hel, Fenrir and Jörmungandr, as well as Vali and Nari/Narfi.</li>
<li><b>Midgard</b>: Earth, is referenced as the term Midgard in Norse mythology.</li>
<li><b>Naglfar</b>: The ship made of the dead’s nails and hair.</li>
<li><b>Norns</b>: The three goddesses of fate.</li>
<li><b>Odin:</b> He is called the All-Father, king and ruler of Asgard. He is married to Freyja, and the father to Thor and Baldr.</li>
<li><b>Ragnarok</b>: The final battle of the gods, prophesied to be the end of everything.</li>
<li><b>Sif</b>: The incarnate celestial key; she is a college student trying to find her way in this brave new world, accompanied by her friends: Ola, Kristen, Chi and Emili.</li>
<li><b>Sleipnir</b>: Odin’s eight-legged horse, and the stallion son of Loki (who Loki bore as a mare).</li>
<li><b>Sparkle Fyre</b>: She is Sif’s dis and only around six inches tall.</li>
<li><b>Thor</b>: Norse god of thunder, and is considered to be the god who protects mankind. He fights with his hammer, Mjolnir.</li>
<li><b>Verdandi</b>: She is one of the three Norns (sisters). She is said to be responsible for the present.</li>
</ul>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// charactersplaces.vue?6875f8ee